<script>
  import Button from '../common/Button.svelte';

  export let img;
  export let alt;
  export let shortcut;
  export let page;
  export let code;
  export let lang = undefined;
  export let user;

  const i18n = {
    edit: {
      cs: 'Upravit',
      en: 'Edit',
    },
  };
</script>

<div class='left-panel'>
  <div class='left-panel-image-and-admin'>
    <img class='left-panel-image-and-admin-image' src='img/{img}' alt={alt}/>

    {#if user}
      <div class='left-panel-image-and-admin-admin'>
        <Button value={i18n.edit[lang]} icon='edit' dark={true} admin={true} disabled={!user.roles.includes('ROLE_ADMIN')}
          onClick={() => { window.location.href = `./#/admin/${page}/${code}`; }}/>
      </div>
    {/if}
  </div>

  <div class='left-panel-shortcut'>
    {shortcut.toUpperCase()}
  </div>
</div>

<style>
  .left-panel {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 20px;

    height: calc(100% - 40px);

    background: var(--grey-1);

    padding: 20px;

    border-radius: var(--radius-lg);
  }

  .left-panel-image-and-admin {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .left-panel-image-and-admin-image {
    width: 300px;
    height: 225px;

    border-radius: var(--radius-lg);
  }

  .left-panel-shortcut {
    font-family: 'Oswald';
    font-size: 128px;
    font-weight: 450;

    line-height: 1;

    color: var(--grey-4);
  }

  :global(body.dark) .left-panel {
    background: var(--grey-8);
  }

  :global(body.dark) .left-panel-shortcut {
    color: var(--grey-5);
  }

  :global(body.dark) .left-panel-image-and-admin-image {
    filter: brightness(88%);
  }

  @media only screen and (max-width: 1050px) {
    .left-panel {
      flex-direction: row;
    }

    .left-panel-shortcut {
      display: flex;
      align-items: center;
    }
  }

  @media only screen and (max-width: 700px) {
    .left-panel-image-and-admin-image {
      width: 100%;
      height: auto;

      aspect-ratio: 4 / 3;
    }

    .left-panel-shortcut {
      display: none;
    }
  }
</style>
